var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scrollWidth > _vm.clientWidth)?_c('div',{staticClass:"table-sticky-bar",on:{"mousemove":_vm.mouseMove,"mousedown":_vm.mouseDown,"mouseup":_vm.mouseUp}},[_c('div',{style:({width: _vm.width, left: `${_vm.left}px`})})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }